import { Component } from '@angular/core';
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { ICellRendererParams } from 'ag-grid-community';

// Renders a Yes/No cell value as a pill. Accepts booleans or the strings 'Yes'/'No' (e.g. from a
// valueFormatter/valueGetter), plus 'Active'/'Inactive' with the same tones; anything else
// (null, '----') renders as plain text so "not applicable" values stay distinguishable from No.
@Component({
    selector: 'app-ag-yes-no-pill-renderer',
    templateUrl: './ag-yes-no-pill-renderer.component.html',
    styleUrl: './ag-yes-no-pill-renderer.component.scss'
})
export class AgYesNoPillRendererComponent implements ICellRendererAngularComp {

  state: 'yes' | 'no' | 'none' = 'none';
  text = '';

  agInit(params: ICellRendererParams): void {
    this.setValue(params);
  }

  refresh(params: ICellRendererParams): boolean {
    this.setValue(params);
    return true;
  }

  private setValue(params: ICellRendererParams) {
    const value = params.valueFormatted ?? params.value;

    if (value === true || value === 'Yes') {
      this.state = 'yes';
      this.text = 'Yes';
    } else if (value === false || value === 'No') {
      this.state = 'no';
      this.text = 'No';
    } else if (value === 'Active' || value === 'Inactive') {
      this.state = value === 'Active' ? 'yes' : 'no';
      this.text = value;
    } else {
      this.state = 'none';
      this.text = value == null ? '' : `${value}`;
    }
  }
}
